import {useMutation} from 'react-query';
import {postSponsor} from '.';
import {toast} from 'react-toastify';
import {AxiosError} from 'axios';

const usePostSponsor = () => {
  const {isLoading, mutate, isSuccess} = useMutation({
    mutationFn: (payload: PostSponsorPayload) => {
      return postSponsor(payload);
    },
    onError: (error: AxiosError<IAxiosErr>) => {
      toast.error(
        error?.response?.data?.message ||
          'مشکلی پیش آمده ،لطفا در زمان دیگری مراجعه فرمایید',
      );
    },
  });
  return {isLoading, mutate, isSuccess};
};

export default usePostSponsor;
